export const CASH_FLOAT_ROUTES = {
  list: '/staff/cash-float',
  newLedger: '/staff/cash-float/new',
  ledgerDetail: '/staff/cash-float/:ledgerId',
} as const;
